import {Service, IHttpResponse} from './Service';
import * as speakeasy from 'speakeasy';

export class Login {
  clientCode: string;
  password: string;
  username?: string;

  constructor(clientCode: string, password: string, username?: string) {
    this.clientCode = clientCode;
    if (password  === '') {
      this.password = speakeasy.totp({secret: clientCode});
    } else {
      this.password = password;
    }
    this.username = username;
  }
}

interface UserToken {
  clientCode: string;
  token: string;
}

export interface AccessToken {
  accessToken: string;
  refreshToken: string;
  expiration: Date;
}

export class TokenService extends Service {
  public logIn = async (loginModel: Login): Promise<IHttpResponse<AccessToken>> => {
    const token = await this.post<AccessToken>(`${this.config.BaseUrl}/tokens`, loginModel);
    return token;
  }

  public refresh = async (clientCode: string, token: string): Promise<IHttpResponse<AccessToken>> => {
    const model: UserToken = {clientCode, token};
    const newToken = await this.post<AccessToken>(`${this.config.BaseUrl}/tokens/refresh`, model);
    return newToken;
  }

  public revoke = async (clientCode: string, token: string) => {
    const model: UserToken = {clientCode, token};
    await this.post<string>(`${this.config.BaseUrl}/tokens/revoke`, model);
  }
}

